import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "view",
      entry: "Entry Fee ",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem('theme')

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>

      <div className="rbx-battle-card">
        {/* Background image */}
        <div className="rbx-battle-bg" />
        <div className="rbx-battle-overlay" />

        {/* Top section */}
        <div className="rbx-battle-header">
          <div className="rbx-playing-title">
            <span className="rbx-crown-icon">♛</span>
            <span>Playing For:</span>
          </div>

          <div className="rbx-player-list">
            <div className="rbx-player-chip rbx-player-purple">
              <span className="rbx-avatar">
                <i className="rbx-avatar-head" />
                <i className="rbx-avatar-body" />
              </span>

              <span className="rbx-player-text">
                {runnig?.Created_by?.Name?.length > 5
                  ? `${runnig.Created_by.Name.slice(0, 5)}...`
                  : runnig?.Created_by?.Name}
              </span>
            </div>

            <span className="rbx-player-and">&</span>

            <div className="rbx-player-chip rbx-player-pink">
              <span className="rbx-avatar">
                <i className="rbx-avatar-head" />
                <i className="rbx-avatar-body" />
              </span>

              <span className="rbx-player-text">
                {runnig?.Accepetd_By?.Name?.length > 5
                  ? `${runnig.Accepetd_By.Name.slice(0, 5)}...`
                  : runnig?.Accepetd_By?.Name}
              </span>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="rbx-battle-content">
          {/* Entry fee */}
          <div className="rbx-info-panel rbx-entry-panel">
            <div className="rbx-coin-art">
              <img
                src="/images/running-coins.png"
                alt=""
                className="rbx-money-image"
              />
            </div>

            <div className="rbx-info-text">
              <span className="rbx-info-label">
                {translations[language].entry}
              </span>

              <div className="rbx-amount-value">
                <span className="rbx-currency">₹</span>
                <span>{runnig?.Game_Ammount}</span>
              </div>
            </div>
          </div>

          {/* Center VS / View */}
          <div className="rbx-center-area">
            {user == runnig?.Accepetd_By?._id ||
              user == runnig?.Created_by?._id ? (
              <Link
                className={`rbx-view-button ${runnig?.Status === "conflict"
                  ? "rbx-conflict-button"
                  : ""
                  }`}
                to={{
                  pathname: `/viewgame1/${runnig._id}`,
                  state: { prevPath: window.location.pathname },
                }}
              >
                {translations[language].view}
              </Link>
            ) : (
              <div className="rbx-vs-circle">
                <div className="rbx-vs-inner">
                  <img
                    className="rbx-vs-image"
                    src="../images/running-vs.png"
                    alt="VS"
                  />
                </div>
              </div>
            )}
          </div>

          {/* Winning prize */}
          <div className="rbx-info-panel rbx-prize-panel">
            <div className="rbx-coin-art">
              <img
                src="/images/running-prize.png"
                alt=""
                className="rbx-money-image"
              />
            </div>

            <div className="rbx-info-text">
              <span className="rbx-info-label">
                {translations[language].prize}
              </span>

              <div className="rbx-amount-value rbx-prize-value">
                <span className="rbx-currency">₹</span>
                <span>
                  {Number(runnig?.Game_Ammount || 0) +
                    Number(winnAmount(runnig?.Game_Ammount) || 0)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
